import { validateProps } from '../../utils';
export const isValidHighlights = highlights => validateProps(highlights, ['clientsReachedOut', 'tasks', 'recurringSchedules']);
//# sourceMappingURL=Highlights.js.map